(() => {
  const clamp = (n, a = 0, b = 1) => Math.max(a, Math.min(b, n));
  const range = (p, a, b) => clamp((p - a) / (b - a));
  const ease = p => p * p * (3 - 2 * p);
  const mix = (a, b, p) => a + (b - a) * p;
  const initialize = (scope = document) => {
    const root = scope.querySelector('[data-maritim-story]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce), (max-height: 599px)');
    const removals = [];
    let stopMotion = () => {};
    const listen = (target, name, fn, options) => {
      target.addEventListener(name, fn, options);
      removals.push(() => target.removeEventListener(name, fn, options));
    };
    root.querySelectorAll('.mf-flight-word').forEach((word, i) => {
      word.style.setProperty('--i', i);
      word.style.setProperty('--fly-x', `${i % 2 ? 16 : -16}px`);
      word.style.setProperty('--fly-r', `${i % 2 ? 3 : -3}deg`);
    });
    const startMotion = () => {
      if (reduced.matches) return;
      root.classList.add('mf-motion');
      let frame = 0, measureFrame = 0, previous = 0, stopped = false;
      const stages = [...root.querySelectorAll('[data-mf-scene]')].map(element => ({
        element, type: element.dataset.mfScene, stage: element.querySelector('[data-mf-stage]'),
        top: 0, length: 1, value: 0, painted: -1
      }));
      const hero = root.querySelector('.mf-hero');
      const heroTitle = hero.querySelector('.mf-hero-title-wrap');
      const numeral = hero.querySelector('.mf-hero-number');
      const orbits = hero.querySelector('.mf-orbits');
      const photo = hero.querySelector('.mf-hero-photo');
      const second = hero.querySelector('.mf-hero-second');
      const bottom = hero.querySelector('.mf-hero-bottom');
      const heroTop = hero.querySelector('.mf-hero-top');
      const progress = hero.querySelector('.mf-scene-progress span');
      const symmetry = root.querySelector('.mf-symmetry');
      const plan = symmetry.querySelector('.mf-plan-frame');
      const steps = [...symmetry.querySelectorAll('.mf-step')];
      const markers = [...symmetry.querySelectorAll('.mf-marker')];
      const tracks = [...symmetry.querySelectorAll('.mf-symmetry-track span')];
      const water = root.querySelector('.mf-water');
      const depthNumber = root.querySelector('[data-mf-depth-number]');
      const detail = root.querySelector('.mf-detail-photo');
      let header = 0, mobile = false, detailTop = 0, detailHeight = 1;
      let heroWidth = 1, heroHeight = 1, imageWidth = 1, imageHeight = 1, imageStartScale = .6, imageStartY = 0, imageEndY = 0;
      const outline = [...getComputedStyle(photo).getPropertyValue('--mf-hero-outline').matchAll(/([\d.]+)%\s+([\d.]+)%/g)].map(match => [Number(match[1]), Number(match[2])]);
      const openOutline = outline.map(([x, y]) => [x < 50 ? 0 : 100, y < 50 ? 0 : 100]);
      const paint = (scene, p) => {
        if (Math.abs(p - scene.painted) < .00015) return;
        scene.painted = p;
        if (scene.type === 'hero') {
          const leave = ease(range(p, .08, .34));
          const expand = ease(range(p, .18, .88));
          const unmask = ease(range(p, .12, .54));
          heroTitle.style.transform = `translate3d(0,${-leave * 65}px,0)`;
          heroTitle.style.opacity = 1 - leave;
          numeral.style.opacity = .25 * (1 - expand);
          orbits.style.opacity = 0;
          photo.style.clipPath = 'polygon(' + outline.map((point, i) => `${mix(point[0], openOutline[i][0], unmask)}% ${mix(point[1], openOutline[i][1], unmask)}%`).join(',') + ')';
          photo.style.opacity = 1;
          photo.style.transform = `translate(-50%,-50%) translateY(${mix(imageStartY, imageEndY, expand)}px) rotate(${(mobile ? -10 : -6) * (1 - expand)}deg) scale(${mix(imageStartScale, 1, expand)})`;
          photo.firstElementChild.style.filter = `brightness(${1 - expand * (mobile ? 0 : .24)})`;
          const textIn = ease(range(p, .7, .92));
          second.style.opacity = textIn;
          second.style.transform = `translate3d(0,${(1 - textIn) * 38}px,0)`;
          bottom.style.opacity = 1 - ease(range(p, .08, .3));
          bottom.style.pointerEvents = p > .3 ? 'none' : '';
          heroTop.style.opacity = 1 - ease(range(p, .45, .64));
          progress.style.transform = `scaleX(${p})`;
        } else if (scene.type === 'symmetry') {
          const active = Math.min(2, Math.floor(p * 3));
          const close = ease(range(p, .18, .4)) * (1 - ease(range(p, .55, .67)));
          plan.style.transform = `scale(${1 + close * .16})`;
          symmetry.classList.toggle('mf-show-cushions', active === 2);
          steps.forEach((step, i) => {
            const enter = i === 0 ? 1 : ease(range(p, i / 3 + .005, i / 3 + .07));
            const leave = i === steps.length - 1 ? 0 : ease(range(p, (i + 1) / 3 - .07, (i + 1) / 3 - .005));
            step.style.opacity = enter * (1 - leave);
            step.style.transform = `translate3d(0,${(mobile ? 0 : -50)}%,0) translateY(${(1 - enter - leave) * 50}px)`;
          });
          markers.forEach((marker, i) => {
            marker.classList.toggle('is-active', i === active);
            marker.style.opacity = active === 2 ? 0 : i === active ? 1 : .2;
          });
          tracks.forEach((track, i) => track.style.setProperty('--fill', clamp(p * 3 - i)));
        } else if (scene.type === 'depth') {
          const fill = ease(range(p, .06, .8));
          water.style.transform = `translate3d(0,${(1 - fill) * 115}%,0)`;
          depthNumber.textContent = '50';
        }
      };
      const measure = () => {
        measureFrame = 0;
        header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        mobile = innerWidth < 700;
        const heroStage = hero.querySelector('[data-mf-stage]');
        heroWidth = heroStage.clientWidth;
        heroHeight = heroStage.clientHeight;
        imageWidth = mobile ? heroWidth : Math.max(heroWidth, heroHeight * 1.5);
        imageHeight = imageWidth / 1.5;
        imageStartScale = (mobile ? heroWidth * .9 : Math.min(heroWidth * .62, innerHeight * .82, 1020)) / (imageWidth * .82);
        imageStartY = heroHeight * (mobile ? .08 : .15) - imageHeight * .075 * imageStartScale;
        imageEndY = mobile ? -heroHeight * .06 : 0;
        photo.style.width = `${imageWidth}px`;
        photo.style.height = `${imageHeight}px`;
        if (mobile) symmetry.style.setProperty('--mf-symmetry-stage-height', `${symmetry.querySelector('[data-mf-stage]').offsetHeight}px`);
        else symmetry.style.removeProperty('--mf-symmetry-stage-height');
        stages.forEach(scene => {
          scene.top = scene.element.getBoundingClientRect().top + scrollY;
          scene.length = Math.max(1, scene.element.offsetHeight - scene.stage.offsetHeight);
          scene.painted = -1;
        });
        detailTop = detail.getBoundingClientRect().top + scrollY;
        detailHeight = detail.offsetHeight;
        wake();
      };
      const draw = now => {
        frame = 0;
        if (stopped || document.hidden) return;
        const dt = previous ? Math.min(50, now - previous) : 16;
        previous = now;
        const speed = 1 - Math.exp(-dt / 85);
        let unsettled = false;
        for (const scene of stages) {
          const target = clamp((scrollY + header - scene.top) / scene.length);
          scene.value = Math.abs(target - scene.value) < .0003 ? target : mix(scene.value, target, speed);
          if (Math.abs(target - scene.value) > .0003) unsettled = true;
          paint(scene, scene.value);
        }
        const detailProgress = clamp((scrollY + innerHeight - detailTop) / (innerHeight + detailHeight));
        detail.style.setProperty('--detail-scale', 1.15 - detailProgress * .15);
        if (unsettled) frame = requestAnimationFrame(draw);
      };
      const wake = () => { if (!frame && !stopped) frame = requestAnimationFrame(draw); };
      const queueMeasure = () => { if (!measureFrame) measureFrame = requestAnimationFrame(measure); };
      const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('mf-reveal-pending');
          reveal.unobserve(entry.target);
        }
      }), {threshold: .08});
      const revealElements = [...document.querySelectorAll('.mf [data-mf-reveal]')];
      revealElements.forEach(el => {
        if (el.getBoundingClientRect().top > innerHeight) {
          el.classList.add('mf-reveal-ready', 'mf-reveal-pending');
          reveal.observe(el);
        }
      });
      const resize = new ResizeObserver(queueMeasure);
      resize.observe(root);
      root.querySelectorAll('img').forEach(img => img.addEventListener('load', queueMeasure, {once: true}));
      addEventListener('scroll', wake, {passive: true});
      addEventListener('resize', queueMeasure, {passive: true});
      document.addEventListener('visibilitychange', wake);
      measure();
      stages.forEach(scene => {scene.value = clamp((scrollY + header - scene.top) / scene.length);paint(scene, scene.value);});
      stopMotion = () => {
        stopped = true;
        cancelAnimationFrame(frame);cancelAnimationFrame(measureFrame);
        resize.disconnect();reveal.disconnect();
        removeEventListener('scroll', wake);removeEventListener('resize', queueMeasure);
        document.removeEventListener('visibilitychange', wake);
        root.querySelectorAll('img').forEach(img => img.removeEventListener('load', queueMeasure));
        revealElements.forEach(el => el.classList.remove('mf-reveal-pending'));
        root.classList.remove('mf-motion');
        symmetry.classList.remove('mf-show-cushions');
        symmetry.style.removeProperty('--mf-symmetry-stage-height');
        [heroTitle,numeral,orbits,photo,photo.firstElementChild,second,bottom,heroTop,progress,plan,water,detail,...steps,...markers,...tracks].forEach(el => el.removeAttribute('style'));
        depthNumber.textContent = '50';
      };
    };
    startMotion();
    listen(reduced, 'change', () => {stopMotion();startMotion();});
    const unload = event => {
      if (!event.target.contains(root)) return;
      stopMotion();removals.forEach(remove => remove());
    };
    listen(document, 'shopify:section:unload', unload);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
